module.exports = __webpack_public_path__ + "img/psbc.9f0c1f00.png";